import { defineStore } from 'pinia'

type State = {
  title: string,
}

export const usePageStore = defineStore('Page', {
  state: (): State => ({
    title: '',
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${__APP_TITLE__}`
    },
  },
})
